import { addVehicleResponse, prefUpdateResponse } from "../util/type_defs";

export function getAmenActivPreferences_5scale() {
	let checkedActivities:JQuery<HTMLElement> = $("input.activity-pref:checked");
	let checkedActivityIDs:Array<{
		ID:number,
		weight:number
	}> = [];
	checkedActivities.each(function() {
		let id:number = parseInt($(this).attr("id").replace(/\D/g,""));
		let weight:number = parseInt($(`#activity-weight-ac-${id}`).val().toString());
		checkedActivityIDs.push({
			ID: id,
			weight: weight
		});
	});
	let checkedAmenities:JQuery<HTMLElement> = $("input.amenity-pref:checked");
	let checkedAmenityIDs:Array<{
		ID:number,
		weight:number
	}> = [];
	checkedAmenities.each(function() {
		let id:number = parseInt($(this).attr("id").replace(/\D/g,""));
		let weight:number = parseInt($(`#amenity-weight-am-${id}`).val().toString());
		checkedAmenityIDs.push({
			ID: id,
			weight: weight
		});
	});

	return {
		"amenities": checkedAmenityIDs,
		"activities": checkedActivityIDs
	};
};

export function getAmenActivPreferences_2scale() {
	let checkedAmenityIDs:Array<{
		ID:number,
		weight:number
	}> = [];
	let checkedActivityIDs:Array<{
			ID:number,
			weight:number
	}> = [];
	$(".genieMatchSelector.active[amenitySelector]").each(function() {
			let id:number = $(this).data("id");
			let level:number = $(this).data("level");
			let weight:number = 0; // Initialize weight
			if (level == 1) {
					weight = 3;
			} else if (level == 2) {
					weight = 5;
			}

			if (weight > 0) {
				checkedAmenityIDs.push({
						ID: id,
						weight: weight
				});
			};
	});
	$(".genieMatchSelector.active[activitySelector]").each(function() {
			let id:number = $(this).data("id");
			let level:number = $(this).data("level");
			let weight:number = 0; // Initialize weight
			if (level == 1) {
					weight = 3;
			} else if (level == 2) {
					weight = 5;
			}

			if (weight > 0) {
				checkedActivityIDs.push({
						ID: id,
						weight: weight
				});
			};
	});
	return {
		"amenities": checkedAmenityIDs,
		"activities": checkedActivityIDs
	};
};

export const send_setPreferences = async (
		amenityIDs:Array<{
			ID:number,
			weight:number
		}>,
		activityIDs:Array<{
			ID:number,
			weight:number
		}>,
		min_p:number,
		max_p:number,
		set_p:boolean,
		userInterests:string
	) => {
	let success:boolean = false;
	let errMsg:string;
	let response:prefUpdateResponse;

	await $.ajax({
		type: "post",
		url: "./setUserPreferences",
		data: JSON.stringify({
			amenities:amenityIDs,
			activities:activityIDs,
			min_p:min_p,
			max_p:max_p,
			set_p:set_p,
			userInterests:userInterests
		}),
		contentType: "application/json",
		dataType: "json",
		success: (data) => {
			success = true;
			response = data;
		},
		error: (xhr, errStr, exc) => {
			errMsg = errStr;
		}
	});

	return new Promise<prefUpdateResponse>((resolve, reject) => {
		if (success) resolve(response);
		else reject(Error(errMsg));
	});
};

export const send_setRvDims = async (length:number, width:number, height:number) => {
	let success:boolean = false;
	let errMsg:string;
	let response:addVehicleResponse;

	await $.ajax({
		type: "post",
		url: "/setUserRvDims",
		data: JSON.stringify({length:length, width:width, height:height}),
		contentType: "application/json",
		dataType: "json",
		success: (data) => {
			success = true;
			response = data;
		},
		error: (xhr, errStr, exc) => {
			errMsg = errStr;
		}
	});

	return new Promise<addVehicleResponse>((resolve, reject) => {
		if (success) resolve(response);
		else reject(Error(errMsg));
	});
};